import {Injectable} from '@angular/core';
import {constants} from '@q9elements/ui-kit/common';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable()
export class TreePaginationService {
  private nodesPerPageSubject = new BehaviorSubject<number>(
    constants.pagination.nodesPerPageDefault
  );
  private nodesPerPage$ = this.nodesPerPageSubject.asObservable().pipe(distinctUntilChanged());

  private rootNodesLengthSubject = new BehaviorSubject<number>(0);
  private rootNodesLength$ = this.rootNodesLengthSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private pageIndexSubject = new BehaviorSubject<number>(0);
  private pageIndex$ = this.pageIndexSubject.asObservable().pipe(distinctUntilChanged());

  private rootNodesLoadingSubject = new BehaviorSubject<boolean>(false);
  private rootNodesLoading$ = this.rootNodesLoadingSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  get pageIndex(): number {
    return this.pageIndexSubject.value;
  }

  setPageIndex(val: number): void {
    this.pageIndexSubject.next(val);
  }

  selectPageIndex(): Observable<number> {
    return this.pageIndex$;
  }

  get nodesPerPage(): number {
    return this.nodesPerPageSubject.value;
  }

  setNodesPerPage(val: number) {
    this.nodesPerPageSubject.next(val);
  }

  get rootNodesLength(): number {
    return this.rootNodesLengthSubject.value;
  }

  setRootNodesLength(val: number): void {
    this.rootNodesLengthSubject.next(val);
  }

  selectRootNodesLength(): Observable<number> {
    return this.rootNodesLength$;
  }

  get rootNodesLoading(): boolean {
    return this.rootNodesLoadingSubject.value;
  }

  setRootNodesLoading(val: boolean): void {
    this.rootNodesLoadingSubject.next(val);
  }

  selectRootNodesLoading(): Observable<boolean> {
    return this.rootNodesLoading$;
  }

  hasNextPage(): boolean {
    const pagesNumber = Math.ceil(this.rootNodesLengthSubject.value / this.nodesPerPage);
    return pagesNumber > this.pageIndexSubject.value + 1;
  }
}
